import React from 'react';
import {ISupplierUserProfile, IFdLiability} from 'constants/interfaces';
import {
  Box,
  Button,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from '@material-ui/core';
import {reduxToggleSidePanel} from 'appredux/actions';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import {ESidePanelView} from 'constants/index';
import {LiabilitySidePanelData} from 'screens/Dashboard/utils/SidePanel/SidePanel';

const EditFdLiabilities = (props: {
  user: ISupplierUserProfile;
  applicationId: number;
  liabilities: IFdLiability[];
}) => {
  const handleEdit = (liability: IFdLiability) => {
    const type = {
      panelType: ESidePanelView.EDIT_FD_LIABILITY,
      data: {
        applicationId: props.applicationId,
        liability: liability,
      } as LiabilitySidePanelData,
    };
    reduxToggleSidePanel(true, type, false);
  };

  const handleAdd = () => {
    const type = {
      panelType: ESidePanelView.EDIT_FD_LIABILITY,
      data: {
        applicationId: props.applicationId,
      } as LiabilitySidePanelData,
    };
    reduxToggleSidePanel(true, type, false);
  };

  return (
    <Box margin={'1rem'}>
      <Box marginLeft={1}>
        <Typography variant="subtitle2" gutterBottom>
          Liabilities
        </Typography>
      </Box>
      <List>
        {props.liabilities
          .sort((a, b) => a!.lender.localeCompare(b!.lender))
          .map((liability) => (
            <ListItem
              key={liability.id}
              button
              onClick={() => handleEdit(liability)}
            >
              <Box display="flex" justifyContent="space-between" width="100%">
                <ListItemText
                  primary={`${liability.lender} (${
                    liability.liabilityAccountType!.name
                  })`}
                />
                <ListItemSecondaryAction>
                  <ChevronRightIcon />
                </ListItemSecondaryAction>
              </Box>
            </ListItem>
          ))}
      </List>
      <Button variant="text" fullWidth onClick={handleAdd} color={'primary'}>
        Add
      </Button>
    </Box>
  );
};

export default EditFdLiabilities;
